import { NgModule } from '@angular/core';
import { MockAuthService } from '@core/auth/auth.mock.service';
import { AuthProdService } from '@core/auth/auth.prod.service';
import { environment } from '../../../environments/environment';

@NgModule({
  providers: [{ provide: AuthProdService, useClass: environment.mock ? MockAuthService : AuthProdService }]
})
export class AuthModule {}
